import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const restrictedSections = ['/connections/', '/properties/', '/messages', '/events', '/retailers'];

const useRestrictedSections = location => {
    const [isRestrictedSection, setIsRestrictedSection] = useState(false);

    useEffect(() => {
        if (!location) return;
        // /my-icsc/connections includes /connections
        setIsRestrictedSection(restrictedSections.some(section => location.includes(section)));
    }, [location]);

    return isRestrictedSection;
};

useRestrictedSections.propTypes = {
    location: PropTypes.string,
};

export default useRestrictedSections;
